/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTokenAllocationDto } from '../../models/create-token-allocation-dto';
import { ProjectResponseDashboardDto } from '../../models/project-response-dashboard-dto';

export interface DashboardProjectsControllerAddOrUpdateTokenAllocationV1$Params {
  projectId: string;
      body: CreateTokenAllocationDto
}

export function dashboardProjectsControllerAddOrUpdateTokenAllocationV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerAddOrUpdateTokenAllocationV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectResponseDashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerAddOrUpdateTokenAllocationV1.PATH, 'patch');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectResponseDashboardDto>;
    })
  );
}

dashboardProjectsControllerAddOrUpdateTokenAllocationV1.PATH = '/v1/dashboard/projects/{projectId}/token-allocations';
